export default "__VITE_PUBLIC_ASSET__e3ab22bc__"